<template>
  <div class="container-fluid">
    <div class="row mt-4">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col ml-n2">
                <h4 class="mb-1">
                  <a>
                    {{$t('PurchaseInstallments.show.PremiumPurchase')}} <strong> {{ item.code }}</strong></a
                  >
                </h4>
              </div>
              <div class="col-auto">
                <router-link
                  :to="path + '/' + item.id + '/edit'"
                  class="btn btn-sm btn-primary"
                  :title="$t('PurchaseInstallments.show.Modification')"
                >
                  <i class="fas fa-edit"></i>
                </router-link>
                <a
                  @click="print(item.id)"
                  class="btn btn-sm btn-primary"
                  :title="$t('PurchaseInstallments.show.Printing')"
                >
                  <i class="fas fa-print"></i>
                </a>
                <a
                  :href="
                    $linkGnirator('/purchaseInstallments/' + item.id + '/pdf')
                  "
                  download
                  class="btn btn-sm btn-primary"
                  :title="$t('PurchaseInstallments.show.DownloadPDF')"
                >
                  <i class="fas fa-download"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-header-title">
              <i class="fal fa-credit-card-front"></i>
              {{$t('PurchaseInstallments.show.PaymentDetails')}}
            </h4>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <table class="table table-sm table-nowrap customed-table-small">
                  <tbody>
                    <tr>
                      <th scope="row">{{$t('PurchaseInstallments.show.PaymentNumber')}}</th>
                      <td>{{ item.code }}</td>
                    </tr>
                    <tr>
                      <th scope="row">{{$t('PurchaseInstallments.show.RegistrationDate')}}</th>
                      <td>{{ $dateFormat(item.created_date) }}</td>
                    </tr>
                    <tr>
                      <th scope="row">{{$t('PurchaseInstallments.show.paymentDate')}}</th>
                      <td>{{ $dateFormat(item.date) }}</td>
                    </tr>
                    <tr>
                      <th scope="row">{{$t('PurchaseInstallments.show.Administrator')}}</th>
                      <td>{{ item.user ? item.user.name : "--" }}</td>
                    </tr>
                    <tr>
                      <th scope="row">{{$t('PurchaseInstallments.show.referenceNumber')}}</th>
                      <td>
                        {{ item.refrance != null ? item.refrance : "--" }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">{{$t('PurchaseInstallments.show.ReceiveFrom')}}</th>
                      <td>
                        <router-link
                          :to="'/customers/' + item.customer.id"
                          v-if="item.client_type == 0"
                          >{{ item.customer.name }}</router-link
                        >
                        <router-link
                          :to="'/suppliers/' + item.supplier.id"
                          v-if="item.client_type == 1"
                          >{{ item.supplier.name }}</router-link
                        >
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">{{$t('PurchaseInstallments.show.PaymentMethod')}}</th>
                      <td scope="row">
                        {{
                          item.paymentMethod != null
                            ? item.paymentMethod.name
                            : "--"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">{{$t('PurchaseInstallments.show.Treasury')}}</th>
                      <td>
                        <router-link
                          :to="'/safes/' + item.safe.id"
                          v-if="item.safe"
                          >{{ item.safe.name }}</router-link
                        >
                        {{ item.safe ? "" : "--" }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-3">
                <div class="price-show">
                  <div class="price-content">
                    <p>{{$t('PurchaseInstallments.show.ReceiveFrom')}}</p>
                    <h1>{{ $moneyFormat(item.cost) }} </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <h4 class="card-header-title">
              <i class="fal fa-user-alt"></i>
              {{ $t('PurchaseInstallments.show.ReceiveFrom') }}
            </h4>
          </div>
          <div class="card-body">
            <table class="table table-sm table-nowrap">
              <thead>
                <tr>
                  <th scope="col">{{$t('PurchaseInstallments.show.customerName')}}</th>
                  <th scope="col">{{$t('PurchaseInstallments.show.ReceivedAmount')}}</th>
                  <th scope="col">{{$t('PurchaseInstallments.show.benefit')}}</th>
                  <th scope="col">{{$t('PurchaseInstallments.show.total')}}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">
                    <router-link
                      :to="'/customers/' + item.customer.id"
                      v-if="item.client_type == 0"
                      >{{ item.customer.name }}</router-link
                    >
                    <router-link
                      :to="'/suppliers/' + item.supplier.id"
                      v-if="item.client_type == 1"
                      >{{ item.supplier.name }}</router-link
                    >
                  </th>
                  <td>{{$moneyFormat(item.cost) }} </td>
                  <td>{{$moneyFormat( item.benefit )}}</td>
                  <td>{{ $moneyFormat(item.total) }} </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <showFile/>
      </div>
    </div>
    <print v-if="printInvoice" :options="$option"></print>
  </div>
</template>
<script>
import axios from "axios";
import showFile from '../elements/show/showFile.vue';
import print from "../../print/purchasePayment.vue";
export default {
  data() {
    return {
      path: "/purchaseInstallments",
      item: {},

      printInvoice: false,
    };
  },
  mounted() {
    this.getitem();
  },
  methods: {
    getitem() {
      axios
        .get(this.$linkGnirator(this.path + "/" + this.$route.params.id))
        .then((response) => {
          this.item = response.data;
        });
    },
    print(id) {
      this.printInvoice = id;
    },
  },
  components: {
    print,
    showFile,
  },
};
</script>
